var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isFlightPathAdmin
    ? _c(
        "div",
        { staticClass: "page-container d-flex flex-row align-stretch" },
        [
          _c(
            "nav",
            { staticClass: "d-flex align-stretch" },
            [
              _c(
                "v-list",
                { attrs: { nav: "", dense: "", width: "256" } },
                [
                  _c(
                    "v-list-item",
                    { attrs: { to: "./admins" } },
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", {
                            domProps: { textContent: _vm._s("Admins") },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    { attrs: { to: "./accounts" } },
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", {
                            domProps: { textContent: _vm._s("Account") },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("main", { staticClass: "flex-grow-1" }, [_c("router-view")], 1),
        ]
      )
    : _c("div", { staticClass: "justify-center align-center fill-height" }, [
        _vm._v("No Access"),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }